import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IGridFilter } from '../../interface/grid-filter';
import { GridFilterBase } from '../grid-filter-base';

@Component({
  standalone: false,
  selector: 'mf-grid-filter-boolean',
  templateUrl: './grid-filter-boolean.component.html',
  styleUrls: ['./grid-filter-boolean.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GridFilterBooleanComponent),
      multi: true,
    },
  ],
})
export class GridFilterBooleanComponent extends GridFilterBase<IGridFilter, boolean | null> {}
